var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHatena(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#171f55;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0C114.63,0,0,114.63,0,256s114.63,256,256,256s256-114.63,256-256S397.38,0,256,0z M256,472 c-119.09,0-216-96.91-216-216S136.91,40,256,40s216,96.91,216,216S375.09,472,256,472z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.58,174.09c17.02-43.87,54.46-68.08,104.76-68.08c58.62,0,103.63,36.69,103.63,84.72 c0,31.77-11.72,49.17-50.3,74.13c-29.12,18.91-35.93,31.39-35.93,66.56h-45.76c-0.76-9.46-1.13-14.37-1.13-18.15 c0-34.04,10.97-50.3,51.44-77.53c19.67-13.24,29.12-27.61,29.12-45.01c0-24.58-21.94-42.74-51.44-42.74 c-27.99,0-51.06,17.4-59,45.38L158.58,174.09z M286.79,358.28v59h-59v-59H286.79z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHatena);
export default __webpack_public_path__ + "static/media/icon-hatena.2d1d35cf789d7905f0ece32c0ea83908.svg";
export { ForwardRef as ReactComponent };